import React, { useEffect, useState } from 'react'
import { faCalendarCheck, faBriefcase, faUser, faUsers } from '@fortawesome/free-solid-svg-icons'
import MenuLateral from '../MenuLateral/MenuLateral';
import PerfilDashboard from '../PerfilDashboard/PerfilDashboard';
import InfoProfesional from '../InfoProfesional/InfoProfesional';
import { Agenda } from '../Agenda/Agenda';
import Servicios from '../Servicios/Servicios';
import { Clientes } from '../Clientes/Clientes';

const ZoneGestion1 = ({ tipoDeNegocio }) => {

    const [profesionalSeleccionado, setProfesionalSeleccionado] = useState(null);

    const [menuItems, setMenuItems] = useState([
        {
            nombreItem: 'MENU1',
            className: 'menu-item-dashboard-active',
            iconMenu: faCalendarCheck,
            menuLabel: 'Mi agenda'
        },
        /*
        {
            nombreItem: 'MENU2',
            className: 'menu-item-dashboard',
            iconMenu: faBriefcase,
            menuLabel: 'Mis servicios'
        },
        */
        {
            nombreItem: 'MENU3',
            className: 'menu-item-dashboard',
            iconMenu: faUsers,
            menuLabel: 'Mis clientes'
        },
        {
            nombreItem: 'MENU0',
            className: 'menu-item-dashboard',
            iconMenu: faUser,
            menuLabel: 'Mi perfil'
        },
    ])

    const [stateMenu, setStateMenu] = useState('MENU1');

    useEffect(() => {
        let usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        if (!!usuarioLocalStorage) {
            const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage);
            setProfesionalSeleccionado(usuarioLocalStorageObj);
        }
    }, []);

    const selecionaMenu = (itemSeleccionado) => {
        setStateMenu(itemSeleccionado.nombreItem)
        const nuevoMenuLateral = menuItems.map(itemMenu => {
            if (itemMenu.nombreItem === itemSeleccionado.nombreItem) {
                return { ...itemMenu, className: 'menu-item-dashboard-active' };
            } else {
                return { ...itemMenu, className: 'menu-item-dashboard' };
            }
        });
        setMenuItems(nuevoMenuLateral);
    };

    const componentMenu = () => {
        switch (stateMenu) {
            case 'MENU0':
                return (
                    <>
                        <PerfilDashboard />
                        <InfoProfesional />
                    </>
                )
            case 'MENU1':
                return (
                    <Agenda profesionalSeleccionado={profesionalSeleccionado} />
                )
            case 'MENU2':
                return (
                    <Servicios />
                )
            case 'MENU3':
                return (
                    <Clientes />
                )
            default:
                return (
                    <></>
                )
        }
    }

    return (
        <>
            <div className="row m-0">
                <div className="col-12 col-sm-12 col-md-3 col-lg-3 p-0" >
                    <MenuLateral menuItems={menuItems} selecionaMenu={selecionaMenu} />
                </div>
                <div className="col-12 col-sm-12 col-md-9 col-lg-9 p-0" >
                    {
                        componentMenu()
                    }
                </div>
            </div>
        </>
    )
}

export default ZoneGestion1